<script lang="ts">
  import { TotalByPaymentMethod } from "@models/payments/TotalByPaymentMethod"
  import { formatCentsAsUsd } from "@util/money"
  export let totalsByPaymentMethod: TotalByPaymentMethod[]
</script>

<div class="grid grid-cols-3 gap-block-4 mt-1">
  {#each totalsByPaymentMethod.filter((t) => t.total > 0) as tbs}
    <div class="col-span-2" data-role="description">Total Paid By {tbs.description}</div>

    <div class="text-right" data-role="total">
      {formatCentsAsUsd(tbs.total)}
    </div>
  {/each}
</div>
